export { default as LogoImage } from '@assets/images/logo.png';
export { default as AitechTokenImage } from '@assets/images/company-logo-head.png';
export { default as UserDefaultImage } from '@assets/images/user.png';
export { default as SolidusAitechLogo } from '@assets/images/solidus-aitech-logo.png';
export { default as SambaNovaLogo } from '@assets/images/samba-nova-logo.png';
